import { gql } from '@apollo/client';

export const updateLivePromptMutation = gql`
  mutation updateLivePrompt(
    $promptId: ID!
    $promptSettingsId: ID!
    $title: String!
    $description: JSON!
    $startDate: DateTime
    $endDate: DateTime
    $coverImage: Upload
  ) {
    updateArticle(where: { id: $promptId }, data: { title: $title, body: $description, coverImage: $coverImage }) {
      id
      title
      body
      shortDescription
      coverImage {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
    }

    updatePromptSetting(where: { id: $promptSettingsId }, data: { startDate: $startDate, endDate: $endDate }) {
      id
      liveStatus
      startDate
      endDate
    }
  }
`;
